import '../../style/index.less';
import './index.less';

// style dependencies
import '../../select/style';
import '../../radio/style';



/** WEBPACK FOOTER **
 ** ./components/calendar/style/index.js
 **/